// dev
// const baseUrl = "http://dev.voyanceecg.com:7890/";
// const baseUrl = "https://uat.voyanceecg.com/";
// const baseUrl = "http://13.201.23.226:7891/"; // Pre-Prod URL
const baseUrl = "https://api.voyanceecg.com/";
// const baseUrl = "http://65.0.204.235:4500/";

//dev secondary
// const baseUrl = "http://3.111.34.132:7400/";

//Production test
// const baseUrl = "http://13.201.23.226:7890/";

// Production Url
// const baseUrl = "https://api.voyanceecg.com/";

export { baseUrl };
